export default "__VITE_ASSET__BYKrxrak__"